export default __webpack_public_path__ + "static/media/searchIconLarge.a99c95c3.svg";